import styles from './index.module.sass';
import mixIcon from '@@/mixing/images/mix.svg';

export const WarehouseBadge = ({
  name,
  sleevesQty,
  price,
  distance,
}: {
  name: string[];
  sleevesQty: number[];
  price: number[];
  distance: number[]
}) => {
  return (
    <div className={styles.root}>
      <div className={styles.warehouseItem}>
        <div className={styles.requisite}>
          <span className={styles.title}>{name[0]}</span>
          <span className={styles.qty}>{sleevesQty} {getDeclension(sleevesQty[0])}</span>
        </div>
        <div className={styles.profit}>
          <span className={styles.label}>стоимость логистики</span>
          <span className={styles.val}>{price[0].toLocaleString('ru-Ru')} ₽<span className={styles.distance}>{distance[0]} км</span></span>
        </div>
      </div>
      <img className={styles.icon} src={mixIcon} alt="icon"/>
      <div className={styles.warehouseItem}>
        <div className={styles.requisite}>
          <span className={styles.title}>{name[1]}</span>
          <span className={styles.qty}>{sleevesQty} {getDeclension(sleevesQty[1])}</span>
        </div>
        <div className={styles.profit}>
          <span className={styles.label}>стоимость логистики</span>
          <span className={styles.val}>{price[1].toLocaleString('ru-Ru')} ₽<span className={styles.distance}>{distance[1]} км</span></span>
        </div>
      </div>
    </div>
  );
};


function getDeclension(count: number) {
    const lastDigit = count % 10;
    const lastTwoDigits = count % 100;
  
    if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
      return 'рукавов';
    }
  
    switch (lastDigit) {
      case 1:
        return 'рукав';
      case 2:
      case 3:
      case 4:
        return 'рукава';
      default:
        return 'рукавов';
    }
  }
